"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANNUAL_BILL_DATE_FORMAT = exports.MONTHLY_BILL_DATE_FORMAT = exports.NEW_DESIGN_DATE_FORMAT = void 0;
exports.NEW_DESIGN_DATE_FORMAT = 'MMM DD, YYYY';
exports.MONTHLY_BILL_DATE_FORMAT = 'DD';
exports.ANNUAL_BILL_DATE_FORMAT = 'MMM DD';
